module.exports = __webpack_public_path__ + "static/img/kdSimulator_4.e19519a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/kdSimulator_4.jpg
// module id = kU+n
// module chunks = 1